import React, { useState, useRef, useEffect } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, Row, ModalHeader, } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb"; 
import { Link } from "react-router-dom";
 import { toast } from "react-toastify";

const InventoryUpload = () => {
  const [partNumber, setPartNumber] = useState("");
  const [isPartValid, setIsPartValid] = useState(false);
  const [boxSerial, setBoxSerial] = useState("");
  const [scannedBoxes, setScannedBoxes] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loadingPartCheck, setLoadingPartCheck] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
const [modal_list, setmodal_list] = useState(false); 
const [isLoading, setIsLoading] = useState(false); 
function tog_list() { 
  setmodal_list(!modal_list); 
}
  const API_BASE = "https://api.hanoch.in/inventory";
  const boxInputRef = useRef(null);

  // Show message with auto-hide
  const showMessage = (text, type, duration = 3000) => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: "", type: "" }), duration);
  };

  // Step 1: Check Part Number
  const handlePartEnter = async (e) => {
    if (e.key === "Enter" && partNumber.trim() !== "") {
      const cleanPart = partNumber.startsWith("1P")
        ? partNumber.slice(2)
        : partNumber;
      setLoadingPartCheck(true);
      try {
        const res = await fetch(`${API_BASE}/check-part/?part_number=${cleanPart}`);
        const data = await res.json();
        setLoadingPartCheck(false);
        if (res.ok && data.exists) {
          setIsPartValid(true);
          showMessage("Part found! Scan the boxes", "success", 5000);
          setPartNumber(cleanPart);
          setTimeout(() => {
            boxInputRef.current?.focus();
          }, 100);
        } else {
          setIsPartValid(false);
          showMessage(data.error || "❌ Part number not found", "error");
        }
      } catch {
        setLoadingPartCheck(false);
        showMessage("⚠️ Error checking part", "error");
      }
    }
  };

  // Step 2: Add scanned box serial
  const handleBoxEnter = (e) => {
    if (e.key === "Enter" && boxSerial.trim() !== "") {
      const cleanBox = boxSerial.startsWith("3S")
        ? boxSerial.slice(2)
        : boxSerial;
      if (scannedBoxes.includes(cleanBox)) {
        showMessage("⚠️ Duplicate box serial!", "error");
        return;
      }
      setScannedBoxes((prev) => [...prev, cleanBox]);
      setBoxSerial("");
    }
  };

  // Remove last scanned box
  const removeLastBox = () => {
    setScannedBoxes((prev) => prev.slice(0, -1));
  };

  // Step 3: Submit all scanned data
  const handleSubmit = async () => {
    if (!partNumber || scannedBoxes.length === 0) {
      showMessage("⚠️ Please scan part and boxes before submitting", "error");
      return;
    }
    setLoadingSubmit(true);
    try {
      const res = await fetch(`${API_BASE}/save-scans/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          part_number: partNumber,
          box_serials: scannedBoxes,
        }),
      });
      const data = await res.json();
      setLoadingSubmit(false);
      if (res.ok) {
        showMessage(
          `✅ ${data.created_count} saved, ${data.skipped_count} skipped`,
          "success",
          5000
        );
        fetchInventory();
        setPartNumber("");
        setBoxSerial("");
        setScannedBoxes([]);
        setIsPartValid(false);
      } else {
        showMessage(data.error || "❌ Error saving scans", "error");
      }
    } catch {
      setLoadingSubmit(false);
      showMessage("⚠️ Server error while saving scans", "error");
    }
  };

  useEffect(() => { 
    fetchInventory();

   }, []);
    const fetchInventory = async () => { 
      try { 
        setIsLoading(true) 
        const response = await fetch("https://api.hanoch.in/inventory/childpart-stock-view/", { 

        }); 
        if (response.ok)
           { 
            const data = await response.json(); 
            setInventoryData(data); 
          } 
          else if (response.status === 401) { 
    // Unauthorized: Log out the user localStorage.removeItem("authUser");
    //  localStorage.removeItem("admin"); 
  } 
    else {
       console.error("Error fetching data:", response.statusText); 
      } 
    } 
    catch (error) {
       console.error("Error fetching data:", error);
       }
        finally{ 
          setIsLoading(false); 
        } 
      };

  return (
    <React.Fragment>
     <div className="page-content">
       <Container fluid> 
        <Breadcrumbs title="OptiMize" breadcrumbItem="Inventory upload" />
         <Row> 
          <Col lg={12}>
           <Card> 
            <CardHeader>
               <h4 className="card-title mb-0">Add inventory</h4> 
               </CardHeader>
                <CardBody> 
                  <div id="customerList">
                     <Row className="g-4 mb-3"> 
                      <Col className="col-sm-auto"> 
                      <div className="d-flex gap-1"> 
                        <Button color="success" className="add-btn" 
                        onClick={() => tog_list()} id="create-btn" >
                           <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add Inventory </Button> 
                            </div> 
                            </Col> 
                            <Col className="col-sm">
                             <div className="d-flex justify-content-sm-end">
                               {/* <div className="search-box ms-2"> <input type="text" className="form-control search" placeholder="Search..." value={searchTerm} onChange={handleSearchTermChange} /> </div> */} 
                               </div> 
                               </Col> 
                               </Row>
                                {isLoading ? ( <div className="text-center"> 
                                  <div className="spinner-border text-primary" role="status"> 
                                    <span className="visually-hidden">Loading...</span>
                                     </div> </div> ) : ( 
                                      <div className="table-responsive table-card mt-3 mb-1"> 
                                      <table className="table align-middle table-nowrap" id="customerTable" > 
                                        <thead className="table-light"> <tr> 
                                          <th className="sort" data-sort="customer_name"> Part number </th> 
                                          <th className="sort" data-sort="customer_name"> Description </th>
                                           <th className="sort" data-sort="phone"> Boxes </th>
                                            <th className="sort" data-sort="phone"> Quantity_per_box </th> 
                                            <th className="sort" data-sort="phone"> Total_quantity </th> 
                                            <th className="sort" data-sort="action"> Action </th> 
                                            </tr>
                                            </thead>
                                             <tbody className="list form-check-all">
                                               {inventoryData === undefined ? ( 
                                                <tr>
                                                   <td colSpan="8" className="text-center"> Loading... </td>
                                                    </tr> 
                                                  ) : inventoryData.length === 0 ? (
                                                     <tr> <td colSpan="8" className="text-center"> 
                                                     No content found </td>
                                             </tr> 
                                             ) : (
inventoryData.map((user, index) => ( 
<tr key={index}>
   <td className="customer_name"> {user.part_number} </td>
    <td className="email">{user.description}</td> 
    <td className="email">{user.boxes}</td>
     <td className="phone">{user.quantity_per_box}</td>
      <td className="">{user.total_quantity}</td> 
      <td>
         <div className="d-flex gap-2"> 
        
             <div className="remove"> 
              <button className="btn btn-danger remove-item-btn" data-bs-toggle="modal" data-bs-target="#deleteRecordModal" 
              // onClick={() => // handleDeleteUser(user.id) // } 
              > Remove </button> 
              </div> </div> </td> </tr>
             )) )} </tbody> 
             </table>
<div className="noresult" style={{ display: "none" }}>
   <div className="text-center"> 
    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#121331,secondary:#08a88a"
     style={{ width: "75px", height: "75px" }} >
      </lord-icon> <h5 className="mt-2">Sorry! No Result Found</h5> 
      <p className="text-muted mb-0"> We've searched more than 150+ Orders We did not find any orders for you search. </p> 
      </div> </div> </div> 
    )}
     {/* <div className="d-flex justify-content-end"> <div className="pagination-wrap hstack gap-2"> <Link className={page-item pagination-prev ${ currentPage === 1 ? "disabled" : "" }} 
     to="#" onClick={handlePrevious} > Previous </Link> <ul className="pagination listjs-pagination mb-0"> <li> Page {currentPage} of {totalPages} 
     </li> </ul> <Link className={page-item pagination-next ${ currentPage === totalPages ? "disabled" : "" }} to="#" onClick={handleNext} > Next </Link> </div> </div> */} 
     </div> </CardBody> </Card> </Col> </Row> </Container> </div>

{/* Add Modal */} 
<Modal isOpen={modal_list} 
toggle={() => { setmodal_list(false); 

}} 
centered > 
<ModalHeader className="bg-light p-3" id="exampleModalLabel"
 toggle={() => { 
  tog_list();

  }} >
     📦 Inventory Upload
      {/* {editUser ? "Edit User" : "Add User"} */} 
      </ModalHeader> 

  <ModalBody>
  <div
      style={{
       // backgroundColor: "#0d1117",
        color: "#c9d1d9",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        //height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "400px", backgroundColor: "#161b22", padding: "20px", borderRadius: "8px" }}>
        {/* <h2 style={{ marginBottom: "20px", textAlign: "center", color: "#58a6ff" }}>📦 Inventory Upload</h2> */}

        {/* Part Input */}
        <label>Part Number</label>
        <input
          type="text"
          value={partNumber}
          onChange={(e) => setPartNumber(e.target.value)}
          onKeyDown={handlePartEnter}
          placeholder="Scan part number"
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: "10px",
            backgroundColor: "#0d1117",
            color: "#c9d1d9",
            border: "1px solid #30363d",
            borderRadius: "5px",
          }}
        />
        {loadingPartCheck && <div style={{ textAlign: "center", marginBottom: "10px" }}>⏳ Checking...</div>}

        {/* Box Input */}
        <label>Box Serial</label>
        <input
          type="text"
          ref={boxInputRef}
          value={boxSerial}
          onChange={(e) => setBoxSerial(e.target.value)}
          onKeyDown={handleBoxEnter}
          placeholder="Scan box serial"
          disabled={!isPartValid}
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: "10px",
            backgroundColor: "#0d1117",
            color: "#c9d1d9",
            border: "1px solid #30363d",
            borderRadius: "5px",
          }}
        />

        {/* Scanned Boxes */}
        <div style={{ marginBottom: "10px" }}>
          <strong>Scanned Boxes:</strong>
          <ul style={{ paddingLeft: "20px" }}>
            {scannedBoxes.length > 5
              ? ["...", ...scannedBoxes.slice(-5)].map((box, idx) => <li key={idx}>{box}</li>)
              : scannedBoxes.map((box, idx) => <li key={idx}>{box}</li>)}
          </ul>
          {scannedBoxes.length > 0 && (
            <button
              onClick={removeLastBox}
              style={{
                backgroundColor: "#21262d",
                color: "#f85149",
                border: "none",
                padding: "5px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              ⬅ Remove Last
            </button>
          )}
        </div>

        {/* Message */}
        {message.text && (
          <p
            style={{
              color: message.type === "error" ? "#f85149" : "#3fb950",
              fontWeight: "bold",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            {message.text}
          </p>
        )}

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={!isPartValid || scannedBoxes.length === 0 || loadingSubmit}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loadingSubmit ? "#30363d" : "#238636",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: loadingSubmit ? "not-allowed" : "pointer",
          }}
        >
          {loadingSubmit ? "⏳ Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  </ModalBody>


<ModalFooter> 
 </ModalFooter>  </Modal> 
</React.Fragment>









  
  );
};

export default InventoryUpload;
